import PropTypes from "prop-types";
import React from "react";

function CardWrapper({ children }) {
  return (
    <div
      style={{
        borderRadius: "16px",
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "16px",
        width: "100%",
        height: "92%",
        justifyContent: "start",
        paddingBottom: "16px",
      }}    
    >
      {children}
    </div>
  );
}

CardWrapper.defaultProps = {
  children: null,
};
CardWrapper.propTypes = {
  children: PropTypes.any,
};

export default CardWrapper;
